import { ResetGameCommand } from "ags/commands/reset-game-fatal-error-command";
import AGSRecordUtils from "ags/integration/builders/ags-record-utils";
import { AGSRecordBuilder } from "ags/integration/builders/records/abstract-ags-record-builder";
import { AGSSpinSchema } from "ags/integration/schema/ags-spin-response-schema";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import FreespinRequestPayload from "slotworks/model/gameplay/requests/freespin-request-payload";
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import slotDefinition from "slotworks/model/slot-definition";
import builderManager from "slotworks/server/builders/builder-manager";
import { RecordBuilder } from "slotworks/server/builders/record-builder";

export class SpinRecordBuilder extends AGSRecordBuilder implements RecordBuilder {

    public filter(request: any, response: any): boolean {
        return response && (request instanceof SpinRequestPayload || request instanceof FreespinRequestPayload);
    }

    public build(gameplay: Gameplay, request: any, response: any) {
        const rootData = this.getRootAGSRecord(response);
        BetModel.creditSizes.values = rootData.config.denominations;
        BetModel.creditsPerLine.values = rootData.config.stakes;
        BetModel.freeBet = this.isFreeBet(rootData.config);

        this.setCreditValues(rootData.config);

        GameState.autoDeductStake = !BetModel.freeBet;

        const platform = rootData.platform;

        if (platform.responsibleGamingEvent) {
            // SG requirement - fatal error
            ResetGameCommand();
            return [];
        }

        super.build(gameplay, request, response);

        const rootSpin = rootData.publicState.spin;
        const spin = this.getLatestAGSSpin(rootData.publicState) as AGSSpinSchema;

        return [this.buildRecord(spin, request instanceof FreespinRequestPayload, rootSpin)];
    }

    public buildRecord(spin: AGSSpinSchema, freespin: boolean, rootSpin: AGSSpinSchema) {
        const record = freespin ? new FreespinRecord() : new SpinRecord();

        if (spin.reels) {
            const grid = AGSRecordUtils.convertreelsToSlotworksGrid(spin.reels);
            record.grid = grid;
        }

        record.reelset = slotDefinition.reelsets.get("base");

        record.cashWon = spin.sumWins;

        record.results = [];
        for (const agsWin of [...spin.wins, ...spin.events]) {
            record.results = record.results.concat(builderManager.buildResult(record, agsWin));
        }

        if (!spin.complete && !freespin) {
            record.hasChildren = true;
        }

        if (!(record instanceof FreespinRecord) || rootSpin.complete) {
            record.lastChild = true;
        }

        return record;
    }
}

export default new SpinRecordBuilder();
